import { render } from "./SubmittedForm.vue?vue&type=template&id=2b3588a2&scoped=true"
import script from "./SubmittedForm.vue?vue&type=script&lang=js"
export * from "./SubmittedForm.vue?vue&type=script&lang=js"

import "./SubmittedForm.vue?vue&type=style&index=0&id=2b3588a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3588a2"]])

export default __exports__